<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/vO9FAC/tc-custom/9781682306758.jpg?1703851148465" alt="This image is the cover for the book On Someone Else's Nickel"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">On Someone Else's Nickel
      </h1>
      <p class="bookDescription body article font2">
        <p><b>The legendary commentator recounts his adventuresome life in the ever-changing world of sport broadcasting in this lively memoir: “I couldn’t put it down” (John McEnroe).</b><br/><br/> Tim Ryan is no doubt the only sportscaster who has crash-landed in the Namib desert, been charged by a rhino in Zimbabwe, herded sheep at the beginning of a Winter Olympics telecast, and dodged flying bottles at a professional boxing match. In his new memoir, Ryan recounts all of these tales and more in the personable, trustworthy voice that sports fans will recognize from his countless television appearances. <br/><br/> Armchair travelers and sports enthusiasts alike will be taken on a riveting journey as Ryan shares anecdotes from his adventures in broadcasting that span thirty sports in more than twenty countries over fifty years. And while the events themselves are impressive—ten Olympic Games, more than three hundred championship boxing matches, Wimbledon and US Open tennis, World Cup Skiing, just to name a few—it’s the lesser-known stories that happened along the way that really stand out in Ryan’s telling.<br/><br/> As he details how he came to call the first Ali-Frazier fight for the Armed Forces Network, or hosted a tennis tournament featuring the McEnroe brothers to raise money for the Alzheimer’s Association, Ryan shines a light on sports and the world beyond sports—the world of family, friends, colleagues, and connections that endure when the game has been won and the mic turned off.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Tim Ryan
      </h2>
      
      <p class="authorDescription body article">Tim Ryan is a retired award-winning sports commentator whose more than fifty-year career has seen him take a unique path to the highest rungs of network television prominence. He has been recognized for his excellence as a broadcaster of NHL hockey, NFL football, boxing, and ski racing, and has ten Olympic Games to his credit. Ryan has served on the national board of the Alzheimer's Association and as a Commissioner of the Smithsonian Institute’s National Portrait Gallery. He has four children from his marriage to his late wife Leona Muir Ryan, and seven grandchildren. He and his wife of ten years, Patricia Benedict Ryan, now live in St. Helena, California.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?4320c782